/**
 * TODO: Modify this helper function to handle the use of Promise.all
 * Utility function to handle asynchronous requests.
 * This is helps us resolve the need for multiple try catch to handle
 * separate errors in instances we have multiple asynchronous requests in one try catch block.
 * @param {*} promise
 * @returns
 */
const handleAsyncRequest = (promise) =>
  // eslint-disable-next-line implicit-arrow-linebreak
  promise.then((data) => [data, undefined]).catch((error) => Promise.resolve([undefined, error]));

export default handleAsyncRequest;
